import clsx from 'clsx';

export const OrgHubWordmark = ({
  size = 16,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <span
      className={clsx('orghub-wordmark', className)}
      style={{
        fontSize: `${size}px`,
        fontWeight: 600,
        letterSpacing: '-0.02em',
        lineHeight: 1.2,
        color: 'currentColor',
        fontFamily: 'inherit',
        whiteSpace: 'nowrap',
        userSelect: 'none',
      }}
    >
      OrgHub
    </span>
  );
};

export const OrgHubMonogram = ({ size = 24 }: { size?: number }) => {
  return (
    <span
      className="orghub-monogram"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: `${size * 0.25}px`,
        backgroundColor: 'var(--affine-v2-text-primary, #0a0a0a)',
        color: 'var(--affine-v2-layer-background-primary, #ffffff)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: `${size * 0.6}px`,
        fontWeight: 700,
        lineHeight: 1,
        fontFamily: 'inherit',
        userSelect: 'none',
      }}
      aria-hidden="true"
    >
      O
    </span>
  );
};
